import { render } from "./UpdateTodos.vue?vue&type=template&id=e1ca5380&scoped=true"
import script from "./UpdateTodos.vue?vue&type=script&lang=js"
export * from "./UpdateTodos.vue?vue&type=script&lang=js"

import "./UpdateTodos.vue?vue&type=style&index=0&id=e1ca5380&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e1ca5380"

export default script